module.exports = __webpack_public_path__ + "img/sherwynwilliams-thumb.efb44f5e.jpg";